(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.TableViewController = (function(superClass) {
    extend(TableViewController, superClass);

    function TableViewController(scope, transitions, rxLayer) {
      this.scope = scope;
      this.transitions = transitions;
      this.rxLayer = rxLayer;
      this.close = bind(this.close, this);
      this.savePopulations = bind(this.savePopulations, this);
      this.changeTruthStripPopulation = bind(this.changeTruthStripPopulation, this);
      this.changeRowBrand = bind(this.changeRowBrand, this);
      this.setTruthStripDefaults = bind(this.setTruthStripDefaults, this);
      TableViewController.__super__.constructor.apply(this, arguments);
      this.scope.rx = this.rxLayer.data;
      this.scope.resize_table = 0;
      this.scope.changeRowBrand = this.changeRowBrand;
      this.scope.averagePop = this.rxLayer.averagePop;
      this.scope.changeTruthStripPopulation = this.changeTruthStripPopulation;
      this.scope.savePopulations = this.savePopulations;
      this.scope.close = this.close;
      this.scope.hasLayer = (function(_this) {
        return function(name) {
          var i, layer, len, ref;
          ref = _this.scope.rx.visual_layers;
          for (i = 0, len = ref.length; i < len; i++) {
            layer = ref[i];
            if (layer.name === name || layer.type === name) {
              return true;
            }
          }
          return false;
        };
      })(this);
      this.scope.filterTinyPolygons = function(polygon) {
        return polygon.acres > 0.1;
      };
      this.scope.$watch('rx.populations', (function(_this) {
        return function() {
          return _this.scope.resize_table++;
        };
      })(this));
      this.scope.$watch('rx.populations', this.setTruthStripDefaults);
    }

    TableViewController.prototype.setTruthStripDefaults = function() {
      var acres, i, index, j, len, len1, poly, polys, ref, ref1, results, strip;
      ref = this.scope.rx.truth_strips;
      results = [];
      for (index = i = 0, len = ref.length; i < len; index = ++i) {
        strip = ref[index];
        polys = this.rxLayer.getStripPolygons(strip);
        if (!polys || polys.length === 0) {
          continue;
        }
        strip.population = (ref1 = polys[0].population) != null ? ref1 : this.scope.averagePop();
        if (!polys[0].population) {
          this.changeTruthStripPopulation(strip);
        }
        acres = 0;
        for (j = 0, len1 = polys.length; j < len1; j++) {
          poly = polys[j];
          acres += parseFloat(poly.acres);
        }
        strip.acres = acres.toFixed(2);
        strip.fillColor = polys[0].fillColor;
        strip.display_id = polys[0].display_id;
        strip.temp_hybrids_id = polys[0].hybrids_id;
        results.push(strip.temp_hybrid_name = polys[0].hybrid_name);
      }
      return results;
    };

    TableViewController.prototype.changeRowBrand = function(row, truth_strip) {
      var h, i, len, results, strip, strips;
      if (truth_strip == null) {
        truth_strip = false;
      }
      h = _.filter(this.scope.rx.planting_selections, {
        brand: {
          id: row.temp_hybrids_id
        }
      });
      if (h.length > 0) {
        row.temp_hybrid_name = h[0].brand.name;
      }
      if (!truth_strip) {
        return;
      }
      strips = this.rxLayer.getStripPolygons(row);
      results = [];
      for (i = 0, len = strips.length; i < len; i++) {
        strip = strips[i];
        strip.temp_hybrids_id = row.temp_hybrids_id;
        results.push(strip.temp_hybrid_name = row.temp_hybrid_name);
      }
      return results;
    };

    TableViewController.prototype.changeTruthStripPopulation = function(row) {
      var i, len, results, strip, strips;
      strips = this.rxLayer.getStripPolygons(row);
      results = [];
      for (i = 0, len = strips.length; i < len; i++) {
        strip = strips[i];
        results.push(strip.temp_population = row.population);
      }
      return results;
    };

    TableViewController.prototype.savePopulations = function() {
      var i, len, pop, ref, row;
      if (this.scope.rx.truth_strips.length > 0) {
        row = this.scope.rx.truth_strips[0];
        row.population = this.scope.averagePop(true);
        this.changeTruthStripPopulation(row);
      }
      ref = this.scope.rx.populations;
      for (i = 0, len = ref.length; i < len; i++) {
        pop = ref[i];
        pop.population = pop.temp_population;
        pop.orig_population = parseInt(pop.temp_population);
        pop.hybrids_id = pop.temp_hybrids_id;
        pop.hybrid_name = pop.temp_hybrid_name;
      }
      return this.scope.tableForm.$setPristine();
    };

    TableViewController.prototype.close = function() {
      var i, len, pop, ref;
      ref = this.scope.rx.populations;
      for (i = 0, len = ref.length; i < len; i++) {
        pop = ref[i];
        pop.temp_population = pop.population;
        pop.temp_hybrids_id = pop.hybrids_id;
        pop.temp_hybrid_name = pop.hybrid_name;
      }
      this.setTruthStripDefaults();
      this.scope.tableForm.$setPristine();
      return this.scope.$parent.$parent.show_fullpage = false;
    };

    return TableViewController;

  })(Controller);

}).call(this);
